import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-states-page-ui',
    templateUrl: './bb-states-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbStatesPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
